// ESM-Huelle fuer lib/scripts/components/CMP_CHourGlass.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CHourGlass (id)
{
    this.construct (id);

    this.name = "CHourGlass";
    this.htmlType = "div";
    
    this.collector = true;
    this.frame = null;
    this.text = null;
    
    this.properties =
    {
        styles:{},
       /* {
            position: "absolute",
            top: "0px",
            left: "0px",
            height: "100%",
            width: "100%",
            visibility: "hidden"
        },*/
        frame:
        {
            styles:{}
           /* {
                backgroundColor: "#B0DFB0",
                width: "45%",
                height: "8%",
                left: "27%",
                top: "45%",
                borderStyle: "solid",
                borderWidth: "2px",
                borderColor: "#D2ECD2",
                borderRightColor: "#3E973E",
                borderBottomColor: "#3E973E",
                zIndex: "2000"
            }*/
        },
        text:
        {
            value: "Bitte haben Sie einen Augenblick Geduld ... ",
            styles:{}
           /* {
                fontSize: "2.0vh",
                text_align: "left",
                position: "absolute",
                left: "25%",
                top: "40%"
            }*/
        },
        image:
        {
            attributes:
            {
                src: "lib/img/10_hourglass.png"
            },
            styles:{}
           /* {
                left: "5%",
                top: "5%",
                height: "81%",
                width: "10%"
            }*/
        }
    }
}

CHourGlass.prototype = new CComponent;

CHourGlass.prototype.prepare = function()
{
    this.frame = this.addChild(CFrame);
    this.frame.properties = combine(this.frame.properties, this.properties.frame);

    this.text = this.frame.addChild(CCaption);
    this.text.properties = combine(this.text.properties, this.properties.text);
    
    this.image = this.frame.addChild(CImage);
    this.image.properties = combine(this.image.properties, this.properties.image);
    
    this.prepared = true;
	return 0;
}

CHourGlass.prototype.show = function (text, cls, fnc, noLog)
{
   if (!noLog)
    log.add(3, "Info", "CHourGlass", text);
    
    POS.overlay.show();

    if(text)
    {
        this.text.properties.value = text;
        this.text.reValue();
    }

	document.getElementById(this.id).style.visibility = "visible";
   /* this.properties.styles.visibility = "visible";
    this.reStyle();
*/
    if (typeof fnc == "function")
        POS.timeout.register("CHourGlassCallback", fnc, cls, 2, 1);
}

CHourGlass.prototype.hide = function ()
{
   /* if (POS.hourGlass.properties.styles.visibility == "hidden")
        return;*/
document.getElementById(POS.hourGlass.id).style.visibility = "hidden";
/*
    POS.hourGlass.properties.styles.visibility = "hidden";
    POS.hourGlass.reStyle();
*/
    POS.overlay.hide();
}

CHourGlass.prototype.isActive = function ()
{
if (document.getElementById(this.id).style.visibility=="hidden"){ 
   // if (this.properties.styles.visibility == "hidden")
        return false;
  //  else if (this.properties.styles.visibility == "visible")
} else if (document.getElementById(this.id).style.visibility == "visible"){
    
    return true;
}
}

CHourGlass.prototype.dialog = function (func,parameter){

var b = {
		Ok : function () {
			$(this).dialog("close");
		}
	}

	if (func) {
		b = {
			Ok : function () {
				func(parameter);
			},
			Cancel : function () {
				$(this).dialog("close");
			}
		}
	}
	var diadiv = $("<div>");
	diadiv.appendTo('.applicationArea');
	$("<div>").dialog({
		modal : true,
		title : message_type,
		//dialogClass: 'ui-icon ui-icon-circle-check',
		buttons : b
	});
	
}

export { CHourGlass };
